import { useAuthStore } from "~/stores/auth";

export default defineNuxtPlugin((nuxtApp) => {
    const authStore = useAuthStore();

    // Create a safe proxy to nuxtApp.$i18n.t that handles the case where i18n might not be ready yet
    const t = (...args) => {
        if (nuxtApp.$i18n && typeof nuxtApp.$i18n.t === 'function') {
            return nuxtApp.$i18n.t(...args);
        }
        return args[0];
    };

    nuxtApp.vueApp.config.globalProperties.t = t;
    nuxtApp.vueApp.config.globalProperties.authStore = authStore;

    return {
        provide: {
            t,
            authStore,
        },
    };
});
